<template>
  <a-layout class="introMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <a-layout class="main-container">
      <a-layout-content class="content">
        <div class="competition-info">
          <section class="intro-section" id="intro">
            <div class="character-container character-top-left">
              <img
                class="character character-top-left"
                :src="isMobile ? require('@/assets/images/introduction/50.png') : require('@/assets/images/introduction/51.png')"
                alt="装饰图像"
                loading="lazy"
                decoding="async"
              >
              <img
                class="character character-top-left-bottom"
                :src="isMobile ? require('@/assets/images/introduction/22.png') : require('@/assets/images/introduction/41.png')"
                alt="装饰图像"
                loading="lazy"
                decoding="async"
              >
            </div>
            <div class="character-container character-middle-left">
              <img
                class="character character-middle-left"
                :src="isMobile ? require('@/assets/images/introduction/52.png') : require('@/assets/images/introduction/53.png')"
                alt="装饰图像"
                loading="lazy"
                decoding="async"
              >
              <img
                class="character character-middle-left-top"
                src="@/assets/images/introduction/28.png"
                alt="装饰图像"
                loading="lazy"
                decoding="async"
                :style="{ transform: isMobile ? 'scale(0.5)' : 'scale(1)' }"
              >
            </div>
            <img
              class="character character-right"
              :src="isMobile ? require('@/assets/images/introduction/48.png') : require('@/assets/images/introduction/49.png')"
              alt="装饰图像"
              loading="lazy"
              decoding="async"
            >

            <h1 class="main-title">{{ competitionIntrodoction.title }}</h1>
            <h2 class="subtitle">{{ competitionIntrodoction.subtitle }}</h2>
            <!-- 大赛及赛项申报概述 -->
            <div class="overview markdown-content" v-html="parsedBasicInfo"></div>

            <!--背景装饰图-->
            <img
              class="illustration illustration-left"
              :src="isMobile ? require('@/assets/images/introduction/4.png') : require('@/assets/images/introduction/7.png')"
              alt="背景装饰"
              loading="lazy"
              decoding="async"
              :class="{ 'animate-float-up-down': !isMobile }"
            >
            <img
              class="illustration illustration-right"
              :src="isMobile ? require('@/assets/images/introduction/1.png') : require('@/assets/images/introduction/2.png')"
              alt="背景装饰"
              loading="lazy"
              decoding="async"
              :class="{ 'animate-float-down-up': !isMobile }"
            >
          </section>

          <div class="content-section">
            <!-- 技术领域 -->
            <div class="content-section tech-domains" id="tech-domains"
                 v-if="Array.isArray(parsedTechDomains) && parsedTechDomains.length > 0">
              <h1 class="titlefnt fnt_42">{{ globalDataArray.siteTemplateLanguage.tech_domains || '赛项技术领域' }}</h1>
              <a-row class="tech-row" :gutter="16" jusify="center">
                <a-col class="tech-col" :span="8" v-for="(domain, index) in parsedTechDomains" :key="index">
                  <div class="domain-card tech-card">
                    <img :src="domain.icon" :alt="domain.name">
                    <h3>{{ domain.name }}</h3>
                    <div class="markdown-container" lang="en">
                      <div class="markdown-content" v-html="parseMarkdown(domain.description)"></div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>

            <!-- 赛事类别 -->
            <div class="content-section competition-types" id="competition-overview"
                 v-if="Array.isArray(parsedCompetitionTypes) && parsedCompetitionTypes.length > 0">
              <h1 class="titlefnt fnt_42">{{ globalDataArray.siteTemplateLanguage.competition_types || '大赛及赛项申报概述' }}</h1>
              <a-row class="type-row" :gutter="16" jusify="center">
                <a-col class="type-col" :span="10" v-for="(type, index) in parsedCompetitionTypes" :key="index">
                  <div class="type-card">
                    <img :src="type.icon" :alt="type.name">
                    <h3>{{ type.name }}</h3>
                    <div class="markdown-content" v-html="parseMarkdown(type.description)"></div>
                  </div>
                </a-col>
              </a-row>
            </div>

            <!-- 合作方式 -->
            <div class="content-section cooperation-mode" id="cooperation-mode"
                 v-if="parsedCooperationMode && parsedCooperationMode.items && parsedCooperationMode.items.length > 0">
              <h1 class="titlefnt fnt_42">{{ globalDataArray.siteTemplateLanguage.cooperation_mode || '赛项运营机制' }}</h1>
              <div class="cooperation-title">
                <h2 class="fnt_42">{{ parsedCooperationMode.title || '合作方式' }}</h2>
                <p>{{ parsedCooperationMode.overview }}</p>
              </div>
              <a-row class="cooperation-row" :gutter="16" jusify="center">
                <a-col class="cooperation-col" :span="6" v-for="(item, index) in parsedCooperationMode.items" :key="index">
                  <div class="cooperation-card">
                    <img :src="item.icon" :alt="item.name">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                  </div>
                  <img class="arrow" src="@/assets/images/introduction/36.png"></img>
                </a-col>
              </a-row>
              <!--分区设置-->
              <div v-if="Array.isArray(parsedCompetitionPartitionType) && parsedCompetitionPartitionType.length > 0">
                <div class="cooperation-title">
                  <h2 class="fnt_42">{{ parsedCompetitionPartitionType[0]?.name || '分区设置' }}</h2>
                  <p>{{ parsedCompetitionPartitionType[0]?.description }}</p>
                </div>
                <div class="custom-tabs-container">
                  <a-tabs v-model="activeKey" centered>
                    <a-tab-pane key="1" :tab="globalDataArray.siteTemplateLanguage.national_competition || '全国统一赛'">
                      <div class="tab-content">
                        <h3>{{ currentTabContent.name }}</h3>
                        <div class="markdown-content" v-html="parseMarkdown(currentTabContent.description)"></div>
                      </div>
                    </a-tab-pane>
                    <a-tab-pane key="2" :tab="globalDataArray.siteTemplateLanguage.regional_competition || '分区赛'" force-render>
                      <div class="tab-content">
                        <h3>{{ currentTabContent.name }}</h3>
                        <div class="markdown-content" v-html="parseMarkdown(currentTabContent.description)"></div>
                      </div>
                    </a-tab-pane>
                  </a-tabs>
                </div>
              </div>
              <!--背景图-->
              <img
                class="illustration illustration-bottom-left"
                :src="isMobile ? require('@/assets/images/introduction/5.png') : require('@/assets/images/introduction/8.png')"
                alt="背景装饰"
                loading="lazy"
                decoding="async"
                :class="{ 'animate-float-up-down': !isMobile }"
              >
              <img
                class="illustration illustration-bottom-right"
                :src="isMobile ? require('@/assets/images/introduction/3.png') : require('@/assets/images/introduction/6.png')"
                alt="背景装饰"
                loading="lazy"
                decoding="async"
                :class="{ 'animate-float-up-down': !isMobile }"
              >
            </div>

            <!-- 运营支持 -->
            <div class="content-section operational-support" id="operational-support"
                 v-if="Array.isArray(parsedOperationalSupport) && parsedOperationalSupport.length > 0">
              <h1 class="titlefnt fnt_42">{{ globalDataArray.siteTemplateLanguage.operational_support || '赛项运营支持' }}</h1>
              <a-row class="support-row" :gutter="16">
                <a-col class="support-col" :span="12" v-for="(support, index) in parsedOperationalSupport" :key="index">
                  <div class="support-card">
                    <img :src="support.icon" :alt="support.name">
                    <h3>{{ support.name }}</h3>
                    <div class="markdown-content" v-html="parseMarkdown(support.description)"></div>
                  </div>
                </a-col>
              </a-row>
            </div>

            <!-- 联系方式 -->
            <h1 class="titlefnt fnt_42" v-if="parsedContactInfo && Object.keys(parsedContactInfo).length > 0">{{ globalDataArray.siteTemplateLanguage.organize_competition || '我要办赛' }}</h1>
            <div class="content-section contact-info backgroundColor" id="organize-competition"
                 v-if="parsedContactInfo && Object.keys(parsedContactInfo).length > 0">
              <!-- 左侧文字内容 -->
              <div class="text-content">
                <h1>{{ parsedContactInfo.contactTitle || '快速高效搭建专属比赛' }}</h1>
                <p class="description">{{ parsedContactInfo.subContactTitle || '帮您快速搭建自己的比赛，一年发布多场比赛，享受平台流量扶持，通过比赛平台孵化AI人才培养生态，拥有独立账户体系和用户管理后台。' }}</p>
                <div class="contact-details">
                  <p>
                    <span class="icon">📞</span>
                    {{ globalDataArray.siteTemplateLanguage.intro_phone || '联系电话' }}:
                    {{ parsedContactInfo.phone || 'init...' }}
                  </p>
                  <p>
                    <span class="icon">✉️</span>
                    {{ globalDataArray.siteTemplateLanguage.intro_email || '邮箱号码' }}:
                    {{ parsedContactInfo.email || 'init...' }}
                  </p>
                  <p>
                    <span class="icon">🏢</span>
                    {{ globalDataArray.siteTemplateLanguage.intro_address || '联系地址' }}:
                    {{ parsedContactInfo.address || 'init...' }}
                  </p>
                </div>
              </div>
              <!-- 右侧二维码 -->
              <!--              <div class="qr-code">-->
              <!--                <img-->
              <!--                  :src="parsedContactInfo.wechat_qrcode || 'placeholder-qr.png'"-->
              <!--                  alt="扫描办赛"-->
              <!--                >-->
              <!--                <p class="qr-text">{{ globalDataArray.siteTemplateLanguage.intro_address || '扫描办赛' }}</p>-->
              <!--              </div>-->
              <!-- 办赛申请表单 -->
              <!-- 底部按钮 -->
              <div class="button-group">
                <a-button
                  type="primary"
                  class="submit-btn"
                  @click="handleApplyCompetition"
                >
                  {{ globalDataArray.siteTemplateLanguage.organize_competition || '填报办赛信息' }}
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>

    <!-- 固定导航 -->
    <div class="fixed-navigation" :class="{ 'visible': showFixedNav }">
      <div class="nav-item" :class="{ active: activeNav === 'tech-domains' }" @click="scrollToSection('tech-domains')" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
        <span class="nav-text">{{ globalDataArray.siteTemplateLanguage.tech_domains || '赛项技术领域' }}</span>
      </div>
      <div class="nav-item" :class="{ active: activeNav === 'competition-overview' }" @click="scrollToSection('competition-overview')" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
        <span class="nav-text">{{ globalDataArray.siteTemplateLanguage.competition_types || '大赛及赛项申报概述' }}</span>
      </div>
      <div class="nav-item" :class="{ active: activeNav === 'cooperation-mode' }" @click="scrollToSection('cooperation-mode')" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
        <span class="nav-text">{{ globalDataArray.siteTemplateLanguage.cooperation_mode || '赛项运营机制' }}</span>
      </div>
      <div class="nav-item" :class="{ active: activeNav === 'operational-support' }" @click="scrollToSection('operational-support')" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
        <span class="nav-text">{{ globalDataArray.siteTemplateLanguage.operational_support || '赛项运营支持' }}</span>
      </div>
      <div class="nav-item" :class="{ active: activeNav === 'organize-competition' }" @click="scrollToSection('organize-competition')" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
        <span class="nav-text">{{ globalDataArray.siteTemplateLanguage.organize_competition || '我要办赛' }}</span>
      </div>
      <div
        class="nav-item back-to-top"
        :class="{
          active: isBackToTopActive || isBackToTopHover,
          hover: isBackToTopHover
        }"
        @click="scrollToTop"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
      >
        <span class="nav-text">{{ globalDataArray.siteTemplateLanguage.back_top || "回到顶部" }}</span>
        <i class="arrow-up">↑</i>
      </div>
    </div>

    <!-- 办赛表单弹窗 -->
    <a-modal
      v-if="!$refs.createCompetitionForm?.isFullscreen"
      :visible="newCompetitionForm.visible"
      :footer="null"
      :closable="false"
      @cancel="closeNewCompetitionForm"
      :width="'80%'"
      :destroy-on-close="true"
      :mask-closable="false"
      :body-style="{ padding: 0 }"
    >
      <create-competition
        :visible="newCompetitionForm.visible"
        @submit="handleNewCompetitionSubmit"
        @cancel="closeNewCompetitionForm"
        @fullscreen-change="handleNewCompetitionFullscreenChange"
        ref="createCompetitionForm"
      />
    </a-modal>
  </a-layout>
</template>

<script>
// import Cookies from 'js-cookie'
import { getIntroduction, saveCompetition } from '@/api/more/more'
import { marked } from 'marked'
import { Tabs } from 'ant-design-vue'
import Cookies from 'js-cookie'

// 配置 marked 解析器 - 允许HTML和样式，保留空白字符
marked.setOptions({
  breaks: true,
  gfm: true,
  sanitize: false, // 允许HTML标签
  async: false,
  xhtml: false, // 使用HTML5风格
  headerIds: false,
  mangle: false
})

export default {
  name: 'Organize',
  components: {
    CreateCompetition: () => import('@/components/createCompetition/createCompetition.vue'),
    ATabs: Tabs,
    ATabPane: Tabs.TabPane
  },
  data() {
    return {
      loading: false,
      competitionIntrodoction: {},
      newCompetitionForm: {
        visible: false
      },
      activeKey: '1',
      showFixedNav: false,
      isMobile: false,
      activeNav: '', // 当前激活的导航
      isBackToTopActive: false, // 点击激活状态
      isBackToTopHover: false, // 鼠标悬停状态
      scrollEndTimer: null, // 滚动结束定时器
      //   页面区块 id 列表，与导航一一对应
      sections: [
        'organize-competition',
        'tech-domains',
        'competition-overview',
        'cooperation-mode',
        'operational-support'
      ]
    }
  },
  // 添加 asyncData 方法用于服务端数据获取
  async asyncData({ store, app }) {
    try {
      // 确保在服务端渲染时使用正确的 baseURL
      const res = await getIntroduction()
      if (res.success && res.result) {
        // 将数据存储到 Vuex store 中
        store.commit('SET_COMPETITION_INTRODUCTION', res.result)
        return { competitionIntrodoction: res.result }
      }
      return { competitionIntrodoction: {}}
    } catch (error) {
      console.error('Error in asyncData:', error)
      // 服务端渲染失败时，返回空对象
      return { competitionIntrodoction: {}}
    }
  },
  computed: {
    parsedBasicInfo() {
      return this.parseMarkdown(this.competitionIntrodoction.basicInfo || '')
    },
    parsedTechDomains() {
      try {
        return JSON.parse(this.competitionIntrodoction.techDomains || '[]')
      } catch (e) {
        return []
      }
    },
    parsedCompetitionTypes() {
      try {
        return JSON.parse(this.competitionIntrodoction.competitionTypes || '[]')
      } catch (e) {
        return []
      }
    },
    parsedCooperationMode() {
      try {
        return JSON.parse(this.competitionIntrodoction.cooperationMode || '{}')
      } catch (e) {
        return { overview: '', items: [] }
      }
    },
    parsedOperationalSupport() {
      try {
        return JSON.parse(this.competitionIntrodoction.operationalSupport || '[]')
      } catch (e) {
        return []
      }
    },
    parsedContactInfo() {
      try {
        return JSON.parse(this.competitionIntrodoction.contactInfo || '{}')
      } catch (e) {
        return {}
      }
    },
    parsedCompetitionPartitionType() {
      try {
        const data = this.competitionIntrodoction.competitionPartitionType || '[]'
        const list = JSON.parse(data)
        return Array.isArray(list) ? list : []
        // return JSON.parse(this.competitionIntrodoction.competitionPartitionType || '{}')
      } catch (e) {
        console.error('解析 competitionPartitionType 出错', e)
        return []
      }
    },
    currentTabContent() {
      const index = parseInt(this.activeKey) - 1 // key 从 1 开始，数组从 0 开始
      return this.parsedCompetitionPartitionType[index] || {}
    }
    // saitiAccessInfo() {
    //   return Cookies.get('saiti_access_info')
    // }
  },
  mounted() {
    // 客户端挂载时，如果 store 中没有数据，则重新获取
    if (!this.$store.state.competitionIntroduction) {
      this.init()
    } else {
      // 如果 store 中有数据，直接使用
      this.competitionIntrodoction = this.$store.state.competitionIntroduction
    }

    // 初始化移动端检测
    this.checkMobile()

    // 确保初始状态正确
    this.isBackToTopActive = false
    this.isBackToTopHover = false
    this.isNavigating = false

    // 添加滚动监听
    window.addEventListener('scroll', this.handleScrollThrottle)

    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScrollThrottle)

    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize)

    // 清理定时器和动画帧
    clearTimeout(this.scrollEndTimer)
    cancelAnimationFrame(this.scrollFrame)

    // 清理状态
    this.isBackToTopActive = false
    this.isBackToTopHover = false
    this.isNavigating = false
  },
  methods: {
    // 检测是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 768 || ('ontouchstart' in window)
    },

    // 强制重置导航状态 - 移动端专用
    forceResetNavigation() {
      if (this.isMobile) {
        this.isNavigating = false
        this.handleScroll()
        this.$forceUpdate()
        console.log('强制重置导航状态, 当前activeNav:', this.activeNav)
      }
    },

    // 处理窗口大小变化
    handleResize() {
      this.checkMobile()
      // 重置回到顶部按钮状态
      this.isBackToTopActive = false
      this.isBackToTopHover = false

      // 延迟触发滚动处理，确保状态重置完成
      this.$nextTick(() => {
        this.handleScrollThrottle()
      })
    },
    // 节流 + requestAnimationFrame 优化滚动监听
    handleScrollThrottle: function() {
      // 只有在非导航动画期间才处理滚动事件
      if (!this.isNavigating) {
        cancelAnimationFrame(this.scrollFrame)
        this.scrollFrame = requestAnimationFrame(this.handleScroll)
      }

      // 移动端添加滚动结束检测，确保惯性滚动结束后正确更新导航状态
      if (this.isMobile) {
        clearTimeout(this.scrollEndTimer)
        this.scrollEndTimer = setTimeout(() => {
          // 滚动结束后，强制检查导航状态（无论是否在导航动画中）
          this.forceResetNavigation()
        }, 150) // 150ms无滚动后认为滚动结束
      }
    },
    handleScroll() {
      // 滚动时重置回到顶部激活状态
      this.isBackToTopActive = false

      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const viewportHeight = window.innerHeight

      // 使用视口高度的百分比作为阈值（例如15vh）
      const threshold = viewportHeight * 0.15 // 相当于15vh

      // 控制固定导航显示（使用5vh作为阈值）
      this.showFixedNav = scrollTop > viewportHeight * 0.05 // 控制固定导航显示

      // 如果滚动到顶部，确保回到顶部按钮状态正确
      if (scrollTop <= 10) {
        this.isBackToTopActive = false
        this.isBackToTopHover = false
      }

      let currentSection = ''

      // 移动端使用更简单的检测策略
      if (this.isMobile) {
        const headerOffset = viewportHeight * 0.2

        // 从上到下遍历，找到第一个顶部接近或进入视口上部的区块
        for (const id of this.sections) {
          const element = document.getElementById(id)
          if (element) {
            const rect = element.getBoundingClientRect()
            const elementTop = rect.top
            const elementBottom = rect.bottom

            // 如果元素顶部在头部偏移量之上或附近，且底部在视口内
            if (elementTop <= headerOffset && elementBottom > headerOffset * 0.5) {
              currentSection = id
              break
            }
          }
        }
      } else {
        // PC端使用原有的逻辑
        const headerOffset = viewportHeight * 0.1

        for (const id of this.sections) {
          const element = document.getElementById(id)
          if (element) {
            const rect = element.getBoundingClientRect()
            const elementTop = rect.top
            const elementBottom = rect.bottom

            if (elementTop <= headerOffset && elementBottom > 0) {
              currentSection = id
              break
            }
          }
        }
      }

      // 如果没有找到合适的区块，使用备选逻辑
      if (!currentSection) {
        for (const id of this.sections) {
          const element = document.getElementById(id)
          if (element) {
            const rect = element.getBoundingClientRect()
            const elementTop = rect.top
            const elementBottom = rect.bottom
            const elementHeight = elementBottom - elementTop

            // 检查元素是否在视口中有足够的可见性
            const visibleHeight = Math.min(elementBottom, viewportHeight) - Math.max(elementTop, 0)
            const isVisible = visibleHeight > elementHeight * 0.2

            if (isVisible) {
              currentSection = id
              break
            }
          }
        }
      }

      // 如果还是没有找到，使用第一个区块
      if (!currentSection && this.sections.length > 0) {
        currentSection = this.sections[0]
      }

      if (currentSection !== this.activeNav) {
        console.log('移动端导航高亮变化:', this.activeNav, '->', currentSection)
        this.activeNav = currentSection
        // 在移动端强制更新视图，确保响应式系统正确更新
        if (this.isMobile) {
          this.$forceUpdate()
        }
      }
    },
    scrollToSection(sectionId) {
      // 使用视口高度的10%作为顶部偏移量（相当于10vh）
      const HEADER_OFFSET = window.innerHeight * 0.1 // 顶部偏移
      const element = document.getElementById(sectionId)

      if (element) {
        // 设置导航状态，暂时禁用滚动监听器的高亮更新
        this.isNavigating = true

        const rect = element.getBoundingClientRect()
        // 计算滚动目标位置：区块顶部 - 头部偏移
        const targetTop = window.scrollY + rect.top - HEADER_OFFSET

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        })

        // 移动端使用更短的延时，然后立即让滚动检测接管
        const delay = this.isMobile ? 300 : 600
        setTimeout(() => {
          this.isNavigating = false
        }, delay)
      }
    },
    scrollToTop() {
      this.isBackToTopActive = true
      this.isNavigating = true

      const startTime = performance.now()
      const startPos = window.scrollY
      const targetTop = 0
      const distance = targetTop - startPos
      const duration = 800

      const scrollAnimation = (timestamp) => {
        const elapsed = timestamp - startTime
        const progress = Math.min(elapsed / duration, 1)
        const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress)
        window.scrollTo(0, startPos + distance * easeProgress)

        if (progress < 1) {
          requestAnimationFrame(scrollAnimation)
        } else {
          setTimeout(() => {
            // 确保状态正确重置
            this.isBackToTopActive = false
            this.isNavigating = false
            this.activeNav = this.sections[0]
            // 强制触发一次滚动处理，确保状态同步
            this.handleScroll()
          }, 100)
        }
      }
      requestAnimationFrame(scrollAnimation)
    },
    // 处理鼠标悬停
    handleMouseEnter() {
      // 只有在非激活状态下才设置悬停状态
      if (!this.isBackToTopActive) {
        this.isBackToTopHover = true
      }
    },

    // 处理鼠标离开
    handleMouseLeave() {
      this.isBackToTopHover = false
    },

    // 处理触摸开始 - 移动端防止hover状态残留
    handleTouchStart(event) {
      if (this.isMobile) {
        // 移动端触摸时移除所有hover状态
        event.target.blur()
      }
    },

    // 处理触摸结束 - 移动端防止hover状态残留
    handleTouchEnd(event) {
      if (this.isMobile) {
        // 移动端触摸结束时强制移除focus状态
        event.target.blur()
        // 延迟一小段时间后强制重置导航状态
        setTimeout(() => {
          this.forceResetNavigation()
        }, 100)

        // 再延迟一段时间后再次强制重置，确保状态正确
        setTimeout(() => {
          this.forceResetNavigation()
        }, 300)
      }
    },
    init() {
      getIntroduction().then(res => {
        if (res.success && res.result) {
          this.competitionIntrodoction = res.result
          // 更新 store
          this.$store.commit('SET_COMPETITION_INTRODUCTION', res.result)
        }
      }).catch(err => {
        console.error('Error fetching introduction:', err)
        this.$message.error('获取数据失败，请刷新页面重试')
      })
    },

    parseMarkdown(content) {
      if (!content) return ''
      try {
        // 先解码HTML实体和Unicode转义序列
        const decodedContent = this.decodeHtmlEntities(content)

        const parsed = marked.parse(decodedContent)
        if (!parsed || parsed.trim() === '') {
          return `<div class="markdown-fallback"><pre>${this.cleanDOMBreakingContent(decodedContent)}</pre></div>`
        }

        // 对解析后的内容进行安全清理，但保留HTML结构
        const cleanedParsed = this.cleanDOMBreakingContent(parsed)
        return cleanedParsed
      } catch (e) {
        console.error('Markdown parsing error:', e)
        return `<div class="markdown-error">
          <p class="error">Markdown解析异常</p>
          <details>
            <summary>查看原始内容</summary>
            <pre>${content}</pre>
          </details>
        </div>`
      }
    },

    // 强化的HTML实体和转义序列解码函数
    decodeHtmlEntities(content) {
      if (!content || typeof content !== 'string') {
        return content
      }

      let decoded = content

      try {
        // 直接解码常见的JSON转义序列，包括空白字符
        if (decoded.includes('\\u003C') || decoded.includes('\\u002F') || decoded.includes('\\"') || decoded.includes('\\u0020') || decoded.includes('\\u0009')) {
          // 直接替换常见的JSON编码字符，包括各种空白字符
          const jsonReplacements = {
            '\\u003C': '<',
            '\\u003E': '>',
            '\\u002F': '/',
            '\\u0026': '&',
            '\\u0022': '"',
            '\\u0027': "'",
            '\\u003D': '=',
            '\\u0020': ' ', // 普通空格
            '\\u00A0': '\u00A0', // 不换行空格 (NBSP)
            '\\u000A': '\n', // 换行
            '\\u000D': '\r', // 回车
            '\\u0009': '\t', // 制表符
            '\\u000B': '\v', // 垂直制表符
            '\\u000C': '\f' // 换页符
          }
          Object.keys(jsonReplacements).forEach(encoded => {
            if (decoded.includes(encoded)) {
              decoded = decoded.replace(new RegExp(encoded, 'g'), jsonReplacements[encoded])
            }
          })
        }

        // 安全地解码Unicode转义序列（\uXXXX格式），保留空白字符
        decoded = decoded.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
          const charCode = parseInt(code, 16)
          // 保留有用的空白字符，跳过危险的控制字符
          if (charCode >= 0x0000 && charCode <= 0x001F &&
              charCode !== 0x0009 && // tab
              charCode !== 0x000A && // 换行
              charCode !== 0x000D && // 回车
              charCode !== 0x000B && // 垂直制表符
              charCode !== 0x000C) {
            return '' // 跳过其他危险的控制字符
          }
          if (charCode >= 0x200B && charCode <= 0x200D) {
            return '' // 跳过零宽字符
          }
          return String.fromCharCode(charCode)
        })

        // 解码各种类型的转义序列，包括空白字符的不同表示形式
        decoded = decoded.replace(/\\n/g, '\n') // 换行
        decoded = decoded.replace(/\\t/g, '\t') // 制表符
        decoded = decoded.replace(/\\r/g, '\r') // 回车
        decoded = decoded.replace(/\\v/g, '\v') // 垂直制表符
        decoded = decoded.replace(/\\f/g, '\f') // 换页符
        decoded = decoded.replace(/\\ /g, ' ') // 转义的空格
        decoded = decoded.replace(/\\"/g, '"') // 双引号
        decoded = decoded.replace(/\\'/g, "'") // 单引号
        decoded = decoded.replace(/\\\\/g, '\\') // 反斜杠（放在最后处理）

        // 手动解码常见的HTML实体，包括各种空白字符
        const htmlEntities = {
          '&amp;': '&',
          '&lt;': '<',
          '&gt;': '>',
          '&quot;': '"',
          '&#39;': "'",
          '&#x27;': "'",
          '&#x2F;': '/',
          '&#x60;': '`',
          '&#x3D;': '=',
          // 空白字符的HTML实体
          '&nbsp;': '\u00A0', // 不换行空格
          '&ensp;': '\u2002', // En空格 (en space)
          '&emsp;': '\u2003', // Em空格 (em space)
          '&thinsp;': '\u2009', // 细空格 (thin space)
          '&#32;': ' ', // 普通空格
          '&#160;': '\u00A0', // 不换行空格 (NBSP)
          '&#9;': '\t', // 制表符
          '&#09;': '\t', // 制表符（前导零）
          '&#x09;': '\t', // 制表符（十六进制）
          '&#x0009;': '\t', // 制表符（十六进制完整）
          '&#13;': '\r', // 回车
          '&#10;': '\n', // 换行
          '&#x0A;': '\n', // 换行（十六进制）
          '&#x0D;': '\r' // 回车（十六进制）
        }

        Object.keys(htmlEntities).forEach(entity => {
          if (decoded.includes(entity)) {
            decoded = decoded.replace(new RegExp(entity, 'g'), htmlEntities[entity])
          }
        })
      } catch (error) {
        // 如果解码失败，至少尝试基本的安全Unicode解码，保留空白字符
        decoded = content.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
          const charCode = parseInt(code, 16)
          // 解码安全字符，包括重要的空白字符
          if ((charCode >= 0x0020 && charCode < 0x200B) || // 基本安全字符范围
              charCode === 0x0009 || // tab
              charCode === 0x000A || // 换行
              charCode === 0x000D || // 回车
              charCode === 0x00A0) { // 不换行空格
            return String.fromCharCode(charCode)
          }
          return ''
        })
      }

      return decoded
    },

    // 清理可能导致DOM错误的字符但保留HTML结构
    cleanDOMBreakingContent(content) {
      if (!content || typeof content !== 'string') {
        return '<p>内容为空</p>'
      }

      try {
        let cleaned = content

        // 1. 移除可能导致appendChild错误的零宽字符和控制字符，但保留有效的空白字符
        cleaned = cleaned.replace(/[\u200B-\u200D\uFEFF]/g, '') // 零宽字符
        // 危险的控制字符，但保留tab(\u0009)、换行(\u000A)、回车(\u000D)
        cleaned = cleaned.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '') // 危险的控制字符

        // 2. 清理BOM和替换字符
        cleaned = cleaned.replace(/^\uFEFF/, '') // 移除BOM
        cleaned = cleaned.replace(/\uFFFD/g, '') // 移除替换字符

        // 3. 移除可能导致DOM解析问题的注释节点
        cleaned = cleaned.replace(/<!--[\s\S]*?-->/g, '')

        // 4. 清理可能导致DOM问题的空属性
        cleaned = cleaned.replace(/\s+(\w+)=""\s*/g, ' ') // 移除空属性
        cleaned = cleaned.replace(/\s+(\w+)="\s*"\s*/g, ' ') // 移除只有空白的属性

        // 5. 最终安全检查
        if (!cleaned.trim()) {
          return '<p>内容为空</p>'
        }

        return cleaned
      } catch (error) {
        console.error('cleanDOMBreakingContent error:', error)
        return `<p style="color: #999;">内容处理出错: ${error.message}</p>`
      }
    },
    async handleApplyCompetition() {
      console.log('handleApplyCompetition 开始执行')
      let token = ''
      const saitiAccessInfo = Cookies.get('saiti_access_info')
      if (saitiAccessInfo != '' && saitiAccessInfo != undefined && saitiAccessInfo != null) {
        token = JSON.parse(saitiAccessInfo).token
      }
      if (token !== '' && token !== undefined) {
        this.showNewCompetitionForm()
      } else {
        this.handleLogin()
      }
    },
    handleLogin() {
      const redirectUrl = encodeURIComponent(location.href)
      Cookies.set('atom_redirect', redirectUrl, { domain: '.atomgit.com', expires: 180, path: '/', secure: true })
      location.href = this.logAuthUrl
    },
    showNewCompetitionForm() {
      this.newCompetitionForm.visible = true
    },
    closeNewCompetitionForm() {
      this.newCompetitionForm.visible = false
    },
    handleNewCompetitionSubmit(formDataArray) {
      this.loading = true
      saveCompetition(formDataArray)
        .then(res => {
          if (res.success) {
            this.$message.success(this.globalDataArray.siteTemplateLanguage.submit_success || '提交成功')
            this.closeNewCompetitionForm()
          } else {
            this.$message.error(res.message || '提交失败')
          }
        })
        .catch(error => {
          console.error('保存失败:', error)
          this.$message.error('系统错误,请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleNewCompetitionFullscreenChange(isFullscreen) {
      // 可以在这里处理全屏状态变化
      console.log('Competition fullscreen changed:', isFullscreen)
    }
  },
  metaInfo() {
    const title = this.globalDataArray.siteInfo.title
    const description = this.globalDataArray.siteInfo.description
    const keywords = this.globalDataArray.siteInfo.keywords
    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'keywords', name: 'keywords', content: keywords }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/competition_introduction.css';

.markdown-content :is(h1, h2, h3, h4, h5, h6):first-of-type {
  text-align: center;
}

.markdown-container {
  lang: en;
}

.overview.markdown-content {
  //margin-left: 4%;
  margin-top: 8%;
  width: 60%;
  height: auto;
  min-height: 200px;
  overflow: visible;
  white-space: normal;
  word-wrap: break-word;
  padding: 20px;

  :deep(h1) {
    margin-bottom: 20px;
  }

  :deep(p) {
    margin: 16px 0;
    line-height: 1.6;
    white-space: pre-line;
  }

  :deep(pre), :deep(code) {
    white-space: pre-wrap;
    background: none;
    padding: 0;
    margin: 0;
  }

  :deep(*:first-child) {
    margin-top: 0;
  }

  :deep(*:last-child) {
    margin-bottom: 0;
  }
}

.markdown-content {
  // 保留空白字符和格式
  white-space: pre-wrap;
  word-wrap: break-word;

  :deep(h1) {
    font-size: 2em;
    margin: 0.67em 0;
  }

  :deep(h2) {
    font-size: 1.5em;
    margin: 0.83em 0;
  }

  :deep(h3) {
    font-size: 1.17em;
    margin: 1em 0;
  }

  :deep(h4) {
    margin: 1.33em 0;
  }

  :deep(h5) {
    font-size: 0.83em;
    margin: 1.67em 0;
  }

  :deep(h6) {
    font-size: 0.67em;
    margin: 2.33em 0;
  }

  :deep(p) {
    margin: 1em 0;
    white-space: pre-wrap; // 保留空格和换行
  }

  :deep(ul), :deep(ol) {
    padding-left: 2em;
    margin: 1em 0;
  }

  :deep(li) {
    margin: 0.5em 0;
    white-space: pre-wrap; // 保留列表项中的空格
  }

  :deep(code) {
    background: #f5f5f5;
    padding: 0.2em 0.4em;
    border-radius: 3px;
    white-space: pre; // 代码块保留所有空白字符
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  }

  :deep(pre) {
    background: #f5f5f5;
    padding: 1em;
    border-radius: 4px;
    overflow-x: auto;
    white-space: pre; // 预格式化文本保留所有空白字符
    font-family: 'Consolas', 'Monaco', 'Courier New', monospace;

    code {
      background: none;
      padding: 0;
    }
  }

  :deep(blockquote) {
    border-left: 4px solid #ddd;
    padding-left: 1em;
    margin: 1em 0;
    color: #666;
    white-space: pre-wrap; // 引用中保留格式
  }

  :deep(img) {
    max-width: 100%;
    height: auto;
  }

  :deep(table) {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;
  }

  :deep(th), :deep(td) {
    border: 1px solid #ddd;
    padding: 0.5em;
    white-space: pre-wrap; // 表格单元格中保留格式
  }

  // 特殊处理：markdown-fallback 和 markdown-error 区域
  :deep(.markdown-fallback) {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 1em;

    pre {
      margin: 0;
      background: none;
      border: none;
      padding: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }

  :deep(.markdown-error) {
    background: #fff5f5;
    border: 1px solid #fed7d7;
    border-radius: 4px;
    padding: 1em;

    .error {
      color: #e53e3e;
      font-weight: bold;
      margin: 0 0 0.5em 0;
    }

    details {
      margin-top: 0.5em;

      summary {
        cursor: pointer;
        color: #666;
        font-size: 0.9em;
      }

      pre {
        margin-top: 0.5em;
        background: #f8f9fa;
        border: 1px solid #e9ecef;
        padding: 0.5em;
        white-space: pre-wrap;
        word-wrap: break-word;
        font-size: 0.85em;
      }
    }
  }
}

.domain-card, .type-card, .support-card .tab-content{
  .markdown-content {
    text-align: left;
  }
}

:deep(.organize-form-modal) {
  &.fullscreen-modal {
    .ant-modal {
      top: 0;
      padding-bottom: 0;
      max-width: 100%;
    }

    .ant-modal-content {
      border-radius: 0;
    }
  }
}

:deep(.content-section.contact-info) {
  margin-bottom: 34px;
  padding: 36px 36px 80px;
  border-radius: 8px;
}

.button-group {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;

  .submit-btn {
    min-width: 120px;
  }

  .new-competition-btn {
    border-color: #1890ff;
    color: #1890ff;

    &:hover {
      border-color: #40a9ff;
      color: white;
    }
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 12px;

    .submit-btn {
      width: 100%;
    }
  }
}

//主背景图
.main-container {
  background-image: url("~@/assets/images/introduction/10.png");
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  width: 100%;
}

/* 移动端使用小背景图 */
@media screen and (max-width: 768px) {
  .main-container {
    background-image: url("~@/assets/images/introduction/9.png");
  }
}

.backgroundColor {
  background-color: rgba(255, 255, 255, 0.4);
  border: 2px solid #fff;
}

.cooperation-title {
  text-align: left;

  h2 {
    margin: 10px;
  }

  p {
    margin: 0 10px 10px;
  }
}

// 分区标签页样式
.custom-tabs-container {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

// 标签页导航栏样式
:deep(.ant-tabs-nav) {
  background-color: rgba(233, 241, 251, 1);
  border-radius: 50px;
  padding: 8px;
  margin-bottom: 0 !important;

  .ant-tabs-nav-wrap {
    justify-content: center;
  }

  .ant-tabs-nav-list {
    display: flex;
    gap: 6px;
  }
}

// 标签按钮样式
:deep(.ant-tabs-tab) {
  height: 50px;
  line-height: 50px;
  min-width: 100px;
  padding: 0 20px !important;
  margin: 0 !important;
  border-radius: 50px !important;
  border: none;
  transition: all 0.2s ease;

  .ant-tabs-tab-btn {
    color: #666666 !important;
    font-size: 14px;
    font-weight: normal !important;
    text-shadow: none !important;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
}

// 选中状态的标签
:deep(.ant-tabs-tab-active) {
  background: #ffffff !important;

  .ant-tabs-tab-btn {
    color: #333333 !important;
  }

  &:hover {
    background: #ffffff !important;
  }
}

// 隐藏下划线
:deep(.ant-tabs-ink-bar) {
  display: none !important;
}

// 内容区域样式
:deep(.ant-tabs-content-holder) {
  background: rgba(255, 255, 255, 0.4);
  border: 2px solid #ffffff;
  border-radius: 20px;
  margin-top: 16px;
}

:deep(.ant-tabs-content) {
  padding: 0;
}

:deep(.ant-tabs-tabpane) {
  align-items: center;
  justify-content: center;
}

// 标签内容样式
.tab-content {
  text-align: center;
  background-color: rgb(255, 255, 255, 0.4);
  border: 2px solid #fff;
  border-radius: 25px;

  h3 {
    font-size: 20px;
    color: #333333;
    margin-bottom: 12px;
    font-weight: 500;
    text-align: left;
    margin: 30px 20px;
  }
}

.arrow {
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: auto;
  z-index: 3;
}

/* 隐藏最后一个箭头 */
.cooperation-col:last-child .arrow {
  display: none;
}

/* cooperation-col 需要相对定位来配合箭头的绝对定位 */
.ant-col.cooperation-col {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 响应式处理 */
@media screen and (max-width: 1199px) {
  .arrow {
    right: -25px;
    width: 16px;
  }
}

//@media screen and (max-width: 767px) {
//  .arrow {
//    display: none; /* 在小屏幕隐藏所有箭头 */
//  }
//}

/* 固定导航样式 */
.fixed-navigation {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateX(100%);
  transition: all 0.3s ease-in-out;

  &.visible {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }

  .nav-item {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 25px;
    padding: 12px 16px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    min-width: 140px;
    text-align: center;
    backdrop-filter: blur(10px);

    .arrow-up {
      color: #1890ff;
    }

    &:hover:not(.active) {
      background: #1890ff;
      color: rgba(255, 255, 255, 0.8);
      transform: translateX(-5px);
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);

      .nav-text {
        color: white;
      }

      .arrow-up {
        color: white;
      }
    }

    .nav-text {
      font-size: 13px;
      font-weight: 500;
      color: #1890ff;
      transition: color 0.3s ease;
    }
  }
}

/* 响应式设计 */
@media screen and (max-width: 1199px) {
  .fixed-navigation {
    right: 20px;
    bottom: 20px;

    .nav-item {
      min-width: 120px;
      padding: 10px 14px;

      .nav-text {
        font-size: 12px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .fixed-navigation {
    right: 15px;
    bottom: 15px;

    .nav-item {
      min-width: 100px;
      padding: 8px 12px;
      margin-bottom: 6px;

      .nav-text {
        font-size: 11px;
      }

      /* 移动端完全禁用hover效果，避免触摸后保留hover状态 */
      &:hover:not(.active) {
        background: rgba(255, 255, 255, 0.95) !important;
        color: initial !important;
        transform: translateX(0) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;

        .nav-text {
          color: #1890ff !important;
        }

        .arrow-up {
          color: #1890ff !important;
        }
      }
    }
  }
  .competition-info {
    .intro-section {
      .overview {
        width: 100%;
      }
    }
  }
  .cooperation-col {
    .arrow {
      display: none;
    }
  }
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}

.nav-item.active {
  background: #1890ff;
  color: white;
  transform: translateX(-5px);

  .nav-text {
    color: white;
  }
}

/* 回到顶部按钮特殊样式 */
.nav-item.back-to-top {
  &.active {
    background: #1890ff;
    color: white;
    transform: translateX(-5px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);

    .nav-text {
      color: white;
    }

    .arrow-up {
      color: white;
    }
  }

  &.hover:not(.active) {
    background: #1890ff;
    color: rgba(255, 255, 255, 0.8);
    transform: translateX(-5px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);

    .nav-text {
      color: white;
    }

    .arrow-up {
      color: white;
    }
  }
}

:deep(.ant-tabs) {
  z-index: 999;
}

//img循环滑动
/* 定义浮动动画 */
@keyframes floatUpDown {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(120px); /* 向上移动距离 */
  }
}

@keyframes floatDownUp {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-120px); /* 向下移动距离 */
  }
}

/* 应用动画 */
.animate-float-up-down {
  animation: floatUpDown 8s ease-in-out infinite;
}

.animate-float-down-up {
  animation: floatDownUp 8s ease-in-out infinite;
}
</style>

